import { useState, useMemo } from 'react';
import { calculateMarketValue, estimateDelta } from './helpers';

function useSortableTable(data, columns) {
  const [sortConfig, setSortConfig] = useState(null);

  const sortedData = useMemo(() => {
    if (!sortConfig) {
      return data;
    }
    return [...data].sort((a, b) => {
      let aVal, bVal;
      if (sortConfig.key === 'marketValue') {
        aVal = calculateMarketValue(a.quantity, a.details?.Price);
        bVal = calculateMarketValue(b.quantity, b.details?.Price);
      } else if (sortConfig.key === 'delta') {
        aVal = estimateDelta(a.details?.Price, a.strike_price, a.expiration_date, a.option_type);
        bVal = estimateDelta(b.details?.Price, b.strike_price, b.expiration_date, b.option_type);
      } else if (sortConfig.key === 'DFVScore') {
        aVal = a.details?.DFVScore;
        bVal = b.details?.DFVScore;
      } else if (sortConfig.key === 'exposure') {
        aVal = calculateMarketValue(a.quantity*-1,a.strike_price);
        bVal = calculateMarketValue(b.quantity*-1,b.strike_price);
      } else if (sortConfig.key === 'premium_paid') {
        aVal = calculateMarketValue(a.quantity*-1,a.option_premium);
        bVal = calculateMarketValue(b.quantity*-1,b.option_premium);
      } else if (sortConfig.key === 'RSI') {
        aVal = parseFloat(a.details?.RSI);
        bVal = parseFloat(b.details?.RSI);
      } else if (sortConfig.key === 'price') {
        aVal = parseFloat(a.details?.Price);
        bVal = parseFloat(b.details?.Price);
      } else if (sortConfig.key === 'quantity') {
        aVal = a.quantity;
        bVal = b.quantity;
      } else if (sortConfig.key === 'priceTargetDiff') {
        aVal = parseFloat(a.details?.PriceTargetDiff);
        bVal = parseFloat(b.details?.PriceTargetDiff);
      } else {
        aVal = a[sortConfig.key];
        bVal = b[sortConfig.key];
      }

      if (typeof aVal === 'string') {
        aVal = aVal.toUpperCase();
        bVal = bVal.toUpperCase();
      }

      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return sortConfig.direction === 'ascending' ? aVal - bVal : bVal - aVal;
      }

      if (aVal < bVal) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (aVal > bVal) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  }, [data, sortConfig]);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortClass = (key) => {
    if (sortConfig?.key === key) {
      return sortConfig.direction === 'descending' ? 'sorted desc' : 'sorted';
    }
    return '';
  };

  return { sortedData, requestSort, getSortClass };
}

export default useSortableTable;
